import { render } from "./VocEditForm.vue?vue&type=template&id=293c0bd8&scoped=true"
import script from "./VocEditForm.vue?vue&type=script&lang=js"
export * from "./VocEditForm.vue?vue&type=script&lang=js"

import "./VocEditForm.vue?vue&type=style&index=0&id=293c0bd8&scoped=true&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-293c0bd8"]])

export default __exports__